import React, { useState } from 'react';
import './BookingForm.css';

const BookingForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, phone, email, service, message } = formData;
    const subject = `Schedule Appointment: ${name}`;
    const body = 
      `Name: ${name}\n` +
      `Phone: ${phone}\n` +
      `Email: ${email}\n` +
      `Service: ${service}\n` +
      `Message: ${message}`;

    // Construct mailto link
    const mailtoLink = `mailto:info@Physero.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    // Open default email app
    window.location.href = mailtoLink;

    // After 2 seconds, if user hasn't left the page, redirect to Gmail compose
    setTimeout(() => {
      // Check if still on the same page (user hasn't navigated away)
      if (document.hasFocus()) {
        const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&to=info@Physero.com&su=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
        window.location.href = gmailLink;
      }
    }, 1000);
  };

  return (
    <section id="booking" className="booking-form-section">
      <div className="container">
        <div className="booking-content">
          <div className="booking-info">
            <h2>Book Your Physiotherapy Session Today</h2>
            <p>Get personalized physiotherapy treatment at the comfort of your home</p>

            <div className="booking-features">
              <div className="feature">
                <span className="feature-icon">🏠</span>
                <span>At-Home Treatment</span>
              </div>
              <div className="feature">
                <span className="feature-icon">👨‍⚕️</span>
                <span>Expert Therapists</span>
              </div>
              <div className="feature">
                <span className="feature-icon">📱</span>
                <span>Easy Booking</span>
              </div>
              <div className="feature">
                <span className="feature-icon">⭐</span>
                <span>4.8 Rating</span>
              </div>
            </div>
          </div>

          <div className="booking-form">
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your Name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="tel"
                  name="phone"
                  placeholder="Phone Number"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <select
                  name="service"
                  value={formData.service}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Service</option>
                  <option value="orthopedic">Orthopedic Physiotherapy</option>
                  <option value="sports">Sports Injury Physiotherapy</option>
                  <option value="post-operative">Post-Operative Physiotherapy</option>
                  <option value="neurological">Neurological Physiotherapy</option>
                  <option value="elderly">Physiotherapy For Elderly</option>
                </select>
              </div>

              <div className="form-group">
                <textarea
                  name="message"
                  placeholder="Additional Message (Optional)"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                ></textarea>
              </div>

              <div className="form-consent">
                <label>
                  <input type="checkbox" required />
                  I authorize Physero to contact me and I understand that this will override the DND status on my mobile number
                </label>
              </div>

              <button type="submit" className="btn-primary btn-large">
                Schedule Your Session
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookingForm;